// extracted by mini-css-extract-plugin
export default {"alreadyPurchasedText":"Purchased_alreadyPurchasedText","purchasedIcon":"Purchased_purchasedIcon","alreadyPurchasedWrapper":"Purchased_alreadyPurchasedWrapper"};